import React from 'react';
import { useParams } from 'react-router-dom';
import ViewImageComponent from '../ViewImageComponent';

import './style.scss';

interface ICardLabelAndTitle{
  content:any;
  attribute:any;
  label:any;
  marginBottom?: string;
  statusComponent?: any;
}
const CardLabelAndTitle = ({
  content, attribute, label, marginBottom, statusComponent,
}:ICardLabelAndTitle) => {
  const { customerId } = useParams<{ customerId: string }>();
  const renderContent = (ele, content) => {
    const value = content?.[ele];

    if (ele && (typeof content?.[ele] === 'object')) {
      return (
        <ViewImageComponent
          pageName="document"
          name={`Lease Agreement.${value?.extention}`}
          payload={value}
          imageType={value?.fileType}
          docType={value?.fileType}
          fileExt={value?.extention}
          hideActions
          merchantId={customerId}
        />
      );
    }
    return <>{value}</>;
  };

  return (
    <div className="row content-card-row-cover">
      {
        attribute?.map((ele, i) => (
          <div key={i} className={ele ? 'col-md content-card-cover' : 'col-md empty-content-card-cover'} style={{ marginBottom }}>
            <div className="card-label">
              {' '}
              {label?.[ele]}
            </div>
            <div className={`card-title ${ele}`}>
              {renderContent(ele, content)}
              {i === 0 && statusComponent && (
                <div className="status-tag">
                  {statusComponent}
                </div>
              )}
            </div>
          </div>
        ))
      }
    </div>
  );
};
export default CardLabelAndTitle;
